import styled from 'styled-components';
import BoxedContent from 'src/ui/molecules/boxed-content';

export const RestartCalculationContainer = styled(BoxedContent)`
  max-width: 570px;
`;
